module.exports = __webpack_public_path__ + "media/LANGUAGE_TEMP_MUSIC.899424b6.mp3";